// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3i7AB","form":"styles_form__1vT0T","item":"styles_item__2WFjO","labels":"styles_labels__2vkxw"};